import { render } from "./ManageMatching.vue?vue&type=template&id=dea5aa5a&scoped=true"
import script from "./ManageMatching.vue?vue&type=script&lang=js"
export * from "./ManageMatching.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_matching.css?vue&type=style&index=0&id=dea5aa5a&scoped=true&lang=css"
import "@/assets/css/components/commonPopup.css?vue&type=style&index=1&id=dea5aa5a&scoped=true&lang=css"
import "./ManageMatching.vue?vue&type=style&index=2&id=dea5aa5a&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea5aa5a"]])

export default __exports__